import React from 'react';

const ForgotPassword = props => {
    return <div>Forgot Password View</div>;
};

export default ForgotPassword;
